import React from "react";
import { useMeals } from "./MealsContext";

function UpdateQuantityMeal({ meal }) {
  const { setCart, cart } = useMeals();

  const cartItem = cart.find((item) => item.meal.id === meal.id);
  const quantity = cartItem ? cartItem.quantity : "";

  const handleQuantityChange = (e) => {
    const newQuantity = Number(e.target.value);

    setCart((prevCart) => {
      let updatedCart = [...prevCart];
      const existingItemIndex = updatedCart.findIndex(
        (cartItem) => cartItem.meal.id === meal.id
      );

      if (existingItemIndex !== -1) {
        if (newQuantity > 0) {
          updatedCart[existingItemIndex].quantity = newQuantity;
        } else {
          updatedCart = updatedCart.filter(
            (_, idx) => idx !== existingItemIndex
          );
        }
      } else if (newQuantity > 0) {
        updatedCart.push({ meal, quantity: newQuantity });
      }

      return updatedCart;
    });
  };

  return (
    <select
      value={quantity}
      onChange={handleQuantityChange}
      className="border border-gray-300 rounded-md text-center w-fit"
    >
      <option value=""></option>
      {[...Array(50).keys()].map((n) => (
        <option key={n + 1} value={n + 1}>
          {n + 1}
        </option>
      ))}
    </select>
  );
}

export default UpdateQuantityMeal;
